// extracted by mini-css-extract-plugin
export default {"logoWrapper":"styles_logoWrapper__nbnee","logoText":"styles_logoText__o+ach"};